import { isInShipperGuideIframe } from '@/utils/shipperGuide'

const useShipperGuide = () => {
  const isShipperGuide = isInShipperGuideIframe()

  return { isShipperGuide }
}

export { useShipperGuide }
